<template>
  <div>
    <el-dialog
      v-if="isRingingCatchAdmin()"
      width="85%"
      top="2%"
      :close-on-click-modal="false"
      :title="$t('production.ringings_manage_permissions')"
      :visible.sync="ringingCatchAdmin"
      @close="closeAdminPermissions()"
    >
      <div class="row">
        <div class="col-12">
          <span style="font-size: 15px; word-break: break-word">
            1. {{ $t('production.ringings_info') }}
          </span>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item
              class="custom-collapse-item"
              :title="$t('production.column_capture_activate_threepoints')"
              name="by-general"
            >
              <div class="row mx-2 mt-4 mb-4">
                <div class="col-sm-12">
                  <master-table :infoTable="businessTableData" :columns="[]">
                    <template slot="addColumns">
                      <el-table-column
                        v-for="column in weekTableColumns"
                        :key="column.label"
                        :min-width="column.minWidth"
                        :prop="column.prop"
                        :label="column.label"
                      >
                        <template slot-scope="props">
                          <div class="align-center-cell-flex">
                            <l-switch
                              class="mt-2"
                              style="display: block"
                              on-text="ON"
                              off-text="OFF"
                              v-model="model[props.row.id][column.prop]"
                            >
                            </l-switch>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="" fixed="right" width="150">
                        <template slot-scope="props">
                          <div class="text-center">
                            <l-button
                              wide
                              type="info"
                              class="btn-filter"
                              v-on:click="updateGeneralPermission(props.row.id)"
                            >
                              {{ $t('common_words.save') }}
                            </l-button>
                          </div>
                        </template>
                      </el-table-column>
                    </template>
                  </master-table>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              class="custom-collapse-item"
              :title="
                $t('production.column_capture_activate_by_user_threepoints')
              "
              name="by-user"
            >
              <card-header
                @searchedQuery="searchedQuery"
                class="mr-3 mt-4"
              ></card-header>
              <master-table
                :defaultSort="{ prop: 'id', order: 'ascending' }"
                :infoTable="queriedData"
                :columns="tableColumns"
                :indexColumn="{
                  show: true,
                  fixed: false,
                }"
              >
                <template slot="addColumns">
                  <table-column-badges
                    prop="users[0].username"
                    textBadge="username"
                    fromData="users"
                    :minWidth="110"
                  />
                </template>
                <template slot="addColumnsOperations">
                  <table-columns-operations
                    v-if="isUpdate()"
                    @handleEdit="handleEdit"
                    :canShow="false"
                    :canDelete="false"
                    :minWidth="110"
                  />
                </template>
              </master-table>
              <card-footer ref="cardfooter" />
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <br />
    </el-dialog>
    <admin-users
      @closeAdminUsers="closeAdminUsers"
      @showHideLoading="showHideLoading"
      @successChangeUser="successChangeUser"
      @catchChangeUser="catchChangeUser"
      :visible="dialogUser"
      :users="users"
      :initialValue="userForm"
    />
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { Switch as LSwitch } from 'src/components';
import AdminUsers from 'src/components/Permissions/AdminUsers.vue';
import configTable from './columns';
import Fuse from 'fuse.js';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: {
    [AdminUsers.name]: AdminUsers,
    LSwitch,
  },
  name: 'admin-journal-permissions',
  computed: {
    ...configTable().Search,
    dynamicModel: () => {
      const response = {};
      Array.from({ length: 15 }, (_, i) => i + 1).forEach((i) => {
        const index = `week_${i}`;
        response[index] = true;
      });
      return response;
    },
  },
  mixins: [MixinPermissions, MixinMasters],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.ringingCatchAdmin = newValue;
      }
    },
    '$i18n.locale': 'setupTable',
  },
  data() {
    return {
      activeName: 'by-general',
      dialogUser: false,
      businessTableColumns: [],
      businessTableData: [],
      field: {
        youths: true,
        bacotas: true,
      },
      model: {},
      pagination: {},
      ringingCatchAdmin: false,
      tableColumns: [],
      users: [],
      userForm: {
        id: [],
        users_old: [],
        permission_id: [],
        module_id: 74,
      },
      weekTableColumns: [],
    };
  },

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.users = this.concatAll(this.users.splice(1));
    },

    /**
     * Manejador de apertura de collapse
     */
    handleCollapse(value) {
      this.updateDataPagination(
        'cardfooter',
        [this.from, this.to, this.total],
        0
      );
    },

    /**
     * Ejecuta las acciones en caso de error al ejecutar
     * edición de usuarios con los permisos seleccionados
     * @param {*} error
     */
    catchChangeUser(error) {
      this.closeAdminUsers();
      this.showMessageErrors(error);
    },

    /**
     * Ejecuta las acciones en caso de éxito al terminar de
     * editar usuarios con los permisos seleccionados
     * @param {*} response
     */
    successChangeUser(response) {
      this.tableData = response.data.data;
      this.closeAdminUsers();
      this.$emit('showNotification', {
        message: `${response.data.message}`,
        type: 'success',
        icon: 'nc-settings-90',
        title: 'Operación exitosa...',
        position: 'top-right',
      });
      this.forceRenderMenu();
    },

    /**
     * Cerrar el formulario de administrador de permisos
     */
    closeAdminPermissions() {
      this.$emit('closeAdminPermissions');
    },

    /**
     * Cerrar el modal de edición de usuarios
     */
    closeAdminUsers() {
      this.dialogUser = false;
    },

    /**
     * Método para abrir el CRUD del administrador de permisos del módulo
     * y cargar la información inicial al dialog de edición
     * @param index
     * @param row
     */
    handleEdit(index, row) {
      this.dialogUser = true;
      const userForm = { ...this.userForm };

      userForm.id = row.users.map((user) => user.id);
      userForm.users_old = userForm.id;
      userForm.permission_id = row.id;

      this.userForm = userForm;
    },

    /**
     * Me permite actualizar de manera general los permisos del
     * módulo para habilitar o deshabilitar los campos de captura
     * @param {*} id
     */
    updateGeneralPermission(id) {
      this.showHideLoading(true);

      const fillValue = {};
      Array.from({ length: 15 }, (_, i) => i + 1).forEach((i) => {
        const index = `week_${i}`;
        fillValue[index] = this.model[id][index];
      });

      const usersBusiness = [...this.$store.state.auth.user.business];
      const businesses_id = usersBusiness
        .filter((item) => item.id !== 1)
        .map((item) => item.id);

      let data = {
        route: 'modules/othervalue',
        model_c: 'Permisos',
        module_id: this.userForm.module_id,
        business_id: 1,
        businesses_id: businesses_id,
        key_json: Object.keys(this.dynamicModel).concat(['youths', 'bacotas']),
        value_key_json: {
          ...fillValue,
          ...{
            youths: this.model[id]['youths'],
            bacotas: this.model[id]['bacotas'],
          },
        },
      };

      Axios.postMasters(data)
        .then((response) => {
          this.showHideLoading();
          this.$emit('showNotification', {
            message: `${response.data.message}`,
            type: 'success',
            icon: 'nc-settings-90',
            title: 'Operación exitosa...',
            position: 'top-right',
          });
          this.updateInfoTable(response.data.data.other_value);
        })
        .catch((error) => this.showMessageErrors(error));
    },

    /**
     * Actualizar las tablas de permisos para la visualización en el front
     * @param {*} others
     */
    updateInfoTable(others) {
      const otherValues = JSON.parse(others);
      const usersBusiness = [...this.$store.state.auth.user.business];
      this.businessTableData = usersBusiness.filter((item) => item.id != 1);

      const exist = [];
      this.businessTableData.forEach((item) => {
        exist.push(!!otherValues[item.id]);
      });

      this.businessTableData = [
        this.businessTableData.length === 0
          ? usersBusiness[0]
          : this.businessTableData[0],
      ];
      const selectedBusiness = this.businessTableData[0].id;
      const tmp = { ...this.field };

      if (exist.some((value) => value)) {
        try {
          Object.keys(tmp).forEach((index) => {
            this.$set(
              tmp,
              index,
              otherValues[selectedBusiness] &&
                otherValues[selectedBusiness][index]
                ? otherValues[selectedBusiness][index]
                : false
            );
          });

          this.$set(this.model, selectedBusiness, tmp);
        } catch (error) {
          this.businessTableData = [];
        }
      } else {
        this.$set(this.model, selectedBusiness, tmp);
        this.businessTableData = [
          this.businessTableData.length === 0
            ? usersBusiness[0]
            : this.businessTableData[0],
        ];
      }

      this.$emit('updateInfoPermission', otherValues);
    },
    setupTable() {
      const { Table, businessTable, weekTable } = configTable();

      this.pagination = { ...Table.pagination };
      this.tableColumns = Table.tableColumns;

      this.businessTableColumns = businessTable.tableColumns;

      this.weekTableColumns = weekTable.tableColumns;
    },
  },

  created() {
    this.field = { ...this.field, ...this.dynamicModel };
    this.setupTable();
    this.showHideLoading(true);
    Promise.all([
      Axios.getMasters('permissions/module/74'),
      Axios.getMasters('users/indexfield'),
      Axios.getMasters('modules/othervalue/74'),
    ])
      .then((response) => {
        const [responsePermission, responseUsers, responseModule] = response;

        this.users = this.concatAll(responseUsers.data.data);
        this.tableData = responsePermission.data.data;
        this.fuseSearch = new Fuse(this.tableData, {
          useExtendedSearch: true,
          threshold: 0.3,
          keys: this.tableColumns.map((prop) => {
            return prop.prop;
          }),
        });
        this.updateInfoTable(responseModule.data.data.other_value);
        this.showHideLoading();
      })
      .catch((error) => {
        this.showHideLoading();
        this.showMessageErrors(error);
      });
  },
};
</script>

<style></style>
